<template>
  <div class="page-teacher">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/course/curr_banner.jpg">
    </div>
    <div class="teacher-section">
      <div class="header w1200 clearfix">
        <div class="header-left">
          <div class="hr"></div>
          <h2>老师</h2>
        </div>
        <div class="header-right">Staff</div>
      </div>
      <div class="contents_wrap">
        <div class="contents">
          <h1>Hug First, Then Teach</h1>
          <p v-show="!this.$store.state.isMobile">Kids 'R' Kids的老师们他们是这样一群人
            <br>他们像爸爸妈妈一样呵护着孩子，他们像哥哥姐姐陪伴孩子玩耍
            <br>同时他们用专业的知识和经验引领孩子成长，用超乎寻常的耐心搭建起孩子面对世界的信心
            <br>他们拥抱着孩子，爱着孩子，而孩子回报给他们的是开心的笑脸、信任的拥抱
            <br>看着孩子们迈着自信的脚步走向未来，是他们最大的满足
          </p>
          <p v-show="this.$store.state.isMobile">Kids 'R' Kids的老师们他们是这样一群人他们像爸爸妈妈一样呵护着孩子，他们像哥哥姐姐陪伴孩子玩耍同时他们用专业的知识和经验引领孩子成长，用超乎寻常的耐心搭建起孩子面对世界的信心他们拥抱着孩子，爱着孩子，而孩子回报给他们的是开心的笑脸、信任的拥抱看着孩子们迈着自信的脚步走向未来，是他们最大的满足</p>
          <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/xiantiao.png">
        </div>
      </div>
      <div class="content1_wrap">
        <div class="content1">
          <img
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_person7.png"
          >
          <h3>Shirley</h3>
          <h2>“</h2>
          <h4>KRK国际幼儿园的团队很强大</h4>
          <p>在教育领域深耕细作38年，Shirley曾在英国访学、美国研修、芬兰教学，有着丰富的国际学校教育及管理经验。加入KRK，是她教育生涯的全新篇章。</p>
          <span></span>
        </div>
      </div>
      <div class="content2_wrap">
        <div class="content2">
          <img
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_person8.png"
          >
          <h3>Keshia</h3>
          <h2>“</h2>
          <h4>KRK照亮了我的事业方向</h4>
          <p>来自曼彻斯特的Keshia毕业于利物浦约翰摩尔斯大学，加入KRK两年多时间，她将自己的经验与对教育的理解付诸实践，也看到了在异国他乡的事业方向。</p>
          <span></span>
        </div>
      </div>
      <div class="content3_wrap">
        <div class="content3">
          <img
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_person6.png"
          >
          <h3>Meng</h3>
          <h2>“</h2>
          <h4>老师与KRK互相吸引</h4>
          <p>Meng是一位母亲。从为宝宝了解幼儿园，到认识凯斯、被凯斯的教学理念和课程体系吸引，投身幼教行业。<br/>作为园所中方教研组长的她，研究生毕业于美国佛罗里达州立大学教育学院，英语专业八级。</p>
          <span></span>
        </div>
      </div>
      <div class="content4_wrap">
        <div class="content4">
          <img
            src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_person9.png"
          >
          <h3>Kona</h3>
          <h2>“</h2>
          <h4>在KRK，每个人都发着光</h4>
          <p>作为一名国际心灵教育院的专业讲师，Kona老师擅长拟声模仿和故事道具制作，她致力于推广儿童绘本“口演童话”，用声音魔法让孩子们爱上绘本、爱上阅读。</p>
          <span></span>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import Header from "@/components/header/Header"; //悬浮头部
import Footer from "@/components/footer/footer"; //底部模块
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {
    Header,
    "v-footer": Footer
  },
  mounted() {},
  beforeRouteUpdate() {},
  methods: {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-teacher {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        width: 228px;
        height: 68px;
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          p {
            width: 100%;
            height: 68px;
            font-size: 24px;
            font-family: PingFangSC-Regular;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
            position: relative;
          }
          ul {
            display: none;
            position: absolute;
            top: -206px;
            left: 0;
            width: 456px;
            height: 204px;
            background: rgba(0, 52, 121, 0.8);
            cursor: pointer;
            li {
              width: 415px;
              height: 36px;
              margin: 2px 20px;
              font-size: 16px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              line-height: 36px;
              color: #fff;
            }
          }
          ul .cour:hover {
            background: rgba(0, 43, 101, 0.8);
          }
        }
      }
      li:first-child :hover ul {
        display: block;
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
      li:hover .cour {
        background: 0;
      }
    }
  }
  .teacher-section {
    width: 100%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    .w1200 {
      width: 1200px !important;
      margin: 0 auto;
    }
    .header {
      width: 1200px;
      height: 110px;
      overflow: hidden;
      margin-top: 126px;
      .header-left {
        float: left;
        .hr {
          width: 96px;
          height: 4px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          width: 375px;
          height: 96px;
          font-size: 48px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #333333;
          line-height: 96px;
        }
        h3 {
          width: 180px;
          height: 29px;
          line-height: 29px;
          background: rgba(174, 149, 79, 1);
          font-size: 24px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: bold;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
        }
      }
      .header-right {
        float: right;
        width: 390px;
        margin-top: 16px;
        margin-right: 20px;
        height: 73px;
        font-size: 73px;
        font-family: TimesNewRomanPS-ItalicMT;
        font-style: italic;
        color: rgba(204, 204, 204, 1);
        line-height: 73px;
        text-align: right;
      }
    }
    .contents_wrap {
      width: 100%;
      height: 280px;
      margin: 0 auto;
      background: #fff;
      .contents {
        margin: 0 auto;
        width: 1200px;
        height: 280px;
        text-align: center;
        position: relative;
        h1 {
          width: 100%;
          height: 83px;
          font-size: 93px;
          font-family: TimesNewRomanPS-BoldMT;
          font-weight: bold;
          color: rgba(208, 208, 208, 0.11);
        }
        p {
          display: block;
          position: absolute;
          left: 0;
          top: 42px;
          width: 100%;
          height: 143px;
          font-size: 16px;
          font-family: ArialMT;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
        img {
          width: 267px;
          height: 10px;
          position: absolute;
          top: 220px;
          left: 464px;
        }
      }
    }
    .content1_wrap {
      width: 100%;
      height: 570px;
      margin: 0 auto;
      background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_bg1.jpg)
        no-repeat;
      .content1 {
        margin: 0 auto;
        width: 1200px;
        height: 570px;
        text-align: center;
        position: relative;
        img {
          width: 414px;
          height: 400px;
          position: absolute;
          top: 67px;
          left: 120px;
        }
        h3 {
          width: 78px;
          height: 27px;
          font-size: 36px;
          font-family: SourceHanSansSC-Bold;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 36px;
          position: absolute;
          top: 130px;
          right: 380px;
        }
        h2 {
          display: block;
          width: 30px;
          height: 22px;
          font-size: 68px;
          font-family: TimesNewRomanPS-BoldMT;
          font-weight: bold;
          color: rgba(174, 149, 79, 1);
          line-height: 102px;
          position: absolute;
          top: 164px;
          right: 400px;
        }
        h4 {
          width: 320px;
          height: 23px;
          font-size: 24px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 36px;
          position: absolute;
          top: 240px;
          right: 263px;
        }
        p {
          width: 394px;
          height: 79px;
          font-size: 16px;
          font-family: ArialMT;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
          position: absolute;
          top: 296px;
          right: 222px;
        }
        span {
          width: 90px;
          height: 5px;
          background: rgba(174, 149, 79, 1);
          position: absolute;
          top: 420px;
          right: 374px;
        }
      }
    }
    .content2_wrap {
      width: 100%;
      height: 575px;
      background: rgba(0, 52, 121, 1);
      margin: 0 auto;
      .content2 {
        margin: 0 auto;
        width: 1200px;
        height: 575px;
        text-align: center;
        position: relative;
        color: rgba(255, 255, 255, 1);
        img {
          width: 414px;
          height: 400px;
          position: absolute;
          top: 80px;
          right: 200px;
        }
        h3 {
          width: 85px;
          height: 35px;
          font-size: 36px;
          font-family: SourceHanSansSC-Bold;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          line-height: 36px;
          position: absolute;
          top: 132px;
          left: 295px;
        }
        h2 {
          display: block;
          width: 30px;
          height: 22px;
          font-size: 68px;
          font-family: TimesNewRomanPS-BoldMT;
          font-weight: bold;
          color: rgba(174, 149, 79, 1);
          line-height: 102px;
          position: absolute;
          top: 164px;
          left: 322px;
        }
        h4 {
          width: 280px;
          height: 25px;
          font-size: 24px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 36px;
          position: absolute;
          top: 242px;
          left: 217px;
        }
        p {
          width: 394px;
          height: 79px;
          font-size: 16px;
          font-family: ArialMT;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 32px;
          position: absolute;
          top: 296px;
          left: 140px;
        }
        span {
          width: 90px;
          height: 5px;
          background: rgba(174, 149, 79, 1);
          position: absolute;
          top: 460px;
          left: 292px;
        }
      }
    }
    .content3_wrap {
      width: 100%;
      height: 580px;
      margin: 0 auto;
      background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_bg2.jpg)
        no-repeat;
      .content3 {
        margin: 0 auto;
        width: 1200px;
        height: 580px;
        text-align: center;
        position: relative;
        img {
          width: 414px;
          height: 400px;
          position: absolute;
          top: 78px;
          left: 120px;
        }
        h3 {
          width: 120px;
          height: 29px;
          font-size: 36px;
          font-family: SourceHanSansSC-Bold;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 36px;
          position: absolute;
          top: 130px;
          right: 360px;
        }
        h2 {
          display: block;
          width: 30px;
          height: 22px;
          font-size: 68px;
          font-family: TimesNewRomanPS-BoldMT;
          font-weight: bold;
          color: rgba(174, 149, 79, 1);
          line-height: 102px;
          position: absolute;
          top: 164px;
          right: 400px;
        }
        h4 {
          width: 340px;
          height: 23px;
          font-size: 24px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 36px;
          position: absolute;
          top: 243px;
          right: 250px;
        }
        p {
          width: 394px;
          height: 79px;
          font-size: 16px;
          font-family: ArialMT;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
          position: absolute;
          top: 300px;
          right: 222px;
        }
        span {
          width: 90px;
          height: 5px;
          background: rgba(174, 149, 79, 1);
          position: absolute;
          top: 456px;
          right: 374px;
        }
      }
    }
    .content4_wrap {
      width: 100%;
      height: 575px;
      background: rgba(255, 255, 255, 1);
      margin: 0 auto;
      .content4 {
        margin: 0 auto;
        width: 1200px;
        height: 575px;
        text-align: center;
        position: relative;
        color: rgba(255, 255, 255, 1);
        img {
          width: 414px;
          height: 400px;
          position: absolute;
          top: 80px;
          right: 200px;
        }
        h3 {
          width: 85px;
          height: 35px;
          font-size: 36px;
          font-family: SourceHanSansSC-Bold;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 36px;
          position: absolute;
          top: 132px;
          left: 295px;
        }
        h2 {
          display: block;
          width: 30px;
          height: 22px;
          font-size: 68px;
          font-family: TimesNewRomanPS-BoldMT;
          font-weight: bold;
          color: rgba(174, 149, 79, 1);
          line-height: 102px;
          position: absolute;
          top: 164px;
          left: 322px;
        }
        h4 {
          width: 288px;
          height: 25px;
          font-size: 24px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 36px;
          position: absolute;
          top: 242px;
          left: 196px;
        }
        p {
          width: 394px;
          height: 79px;
          font-size: 16px;
          font-family: ArialMT;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
          position: absolute;
          top: 296px;
          left: 140px;
        }
        span {
          width: 90px;
          height: 5px;
          background: rgba(174, 149, 79, 1);
          position: absolute;
          top: 424px;
          left: 292px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page-teacher {
    .banner {
      padding-top: 45px;
    }
    .teacher-section {
      .w1200 {
        width: 100%!important;
      }
      .header {
        width: 100%;
        height: 60px;
        overflow: hidden;
        margin-top: 39px;
        box-sizing: border-box;
        padding-left: 8%;
        .header-left {
          width: 100%;
          .hr {
            width: 10.8%;
            height: 3px;
          }
          h2 {
            width: 100%;
            height: 22px;
            font-size: 21px;
            line-height: 22px;
            padding-top: 11px;
          }
          h3 {
            width: 180px;
            height: 29px;
            line-height: 29px;
            background: rgba(174, 149, 79, 1);
            font-size: 24px;
            font-family: TimesNewRomanPS-BoldItalicMT;
            font-weight: bold;
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            text-align: center;
          }
        }
        .header-right {
          display: none;
        }
      }
      .contents_wrap {
        width: 100%;
        height: 240px;
        margin: 0 auto;
        background: #fff;
        .contents {
          margin: 0 auto;
          width: 100%;
          height: 240px;
          text-align: center;
          position: relative;
          h1 {
            display: none;
          }
          p {
            display: block;
            position: absolute;
            box-sizing: border-box;
            padding: 0 9.7%;
            left: 0;
            top: 2px;
            width: 100%;
            height: 200px;
            font-size: 14px;
            line-height: 25px;
          }
          img {
            width: 50%;
            height: auto;
            position: absolute;
            top: 196px;
            left: 25%;
          }
        }
      }
      .content1_wrap {
        width: 100%;
        height: 580px;
        margin: 0 auto;
        background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_bg1.jpg)
          no-repeat;
        background-position: 58% 100%;
        .content1 {
          margin: 0 auto;
          width: 100%;
          height: 580px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: initial;
          img {
            width: 65%;
            height: auto;
            position: initial;
            margin-top: 45px;
          }
          h3 {
            width: 100%;
            height: 26px;
            font-size: 26px;
            line-height: 26px;
            position: initial;
            margin-top: 15px;
          }
          h2 {
            display: block;
            width: 100%;
            height: 25px;
            font-size: 30px;
            line-height: 30px;
            position: initial;
          }
          h4 {
            width: 100%;
            height: 28px;
            font-size: 18px;
            line-height: 28px;
            position: initial;
            margin-bottom: 15px;

          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding: 0 7.3%;
            height: 62px;
            font-size: 13px;
            line-height: 21px;
            position: initial;
            margin-bottom: 25px;
          }
          span {
            width: 20%;
            height: 4px;
            background: rgba(174, 149, 79, 1);
            position: initial;
          }
        }
      }
      .content2_wrap {
        width: 100%;
        height: 575px;
        background: rgba(0, 52, 121, 1);
        margin: 0 auto;
        .content2 {
          margin: 0 auto;
          width: 100%;
          height: 575px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: initial;
          img {
            width: 65%;
            height: auto;
            position: initial;
            margin-top: 35px;
          }
          h3 {
             width: 100%;
            height: 26px;
            font-size: 26px;
            line-height: 26px;
            position: initial;
            margin-top: 15px;
          }
          h2 {
            display: block;
            width: 100%;
            height: 25px;
            font-size: 30px;
            line-height: 30px;
            position: initial;
          }
          h4 {
            width: 100%;
            height: 28px;
            font-size: 18px;
            line-height: 28px;
            position: initial;
            margin-bottom: 15px;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding: 0 7.3%;
            height: 103px;
            font-size: 13px;
            line-height: 21px;
            position: initial;
            margin-bottom: 25px;
          }
          span {
            width: 20%;
            height: 4px;
            background: rgba(174, 149, 79, 1);
            position: initial;
          }
        }
      }
      .content3_wrap {
        width: 100%;
        height: 580px;
        margin: 0 auto;
        background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/teacher/teacher_bg2.jpg)
          no-repeat;
        background-position: 58% 100%;
        .content3 {
          margin: 0 auto;
          width: 100%;
          height: 580px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: initial;
          img {
            width: 65%;
            height: auto;
            position: initial;
            margin-top: 45px;
          }
          h3 {
            width: 100%;
            height: 26px;
            font-size: 26px;
            line-height: 26px;
            position: initial;
            margin-top: 15px;
          }
          h2 {
            display: block;
            width: 100%;
            height: 25px;
            font-size: 30px;
            line-height: 30px;
            position: initial;
          }
          h4 {
            width: 100%;
            height: 28px;
            font-size: 18px;
            line-height: 28px;
            position: initial;
            margin-bottom: 15px;

          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding: 0 7.3%;
            height: 83px;
            font-size: 13px;
            line-height: 21px;
            position: initial;
            margin-bottom: 25px;
          }
          span {
            width: 20%;
            height: 4px;
            background: rgba(174, 149, 79, 1);
            position: initial;
          }
        }
      }
      .content4_wrap {
        width: 100%;
        height: 575px;
        background: rgba(255, 255, 255, 1);
        margin: 0 auto;
        .content4 {
          margin: 0 auto;
          width: 100%;
          height: 520px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: initial;
          img {
            width: 65%;
            height: auto;
            position: initial;
            margin-top: 35px;
          }
          h3 {
            width: 100%;
            height: 26px;
            font-size: 26px;
            line-height: 26px;
            position: initial;
            margin-top: 15px;
          }
          h2 {
            display: block;
            width: 100%;
            height: 25px;
            font-size: 30px;
            line-height: 30px;
            position: initial;
          }
          h4 {
            width: 100%;
            height: 28px;
            font-size: 18px;
            line-height: 28px;
            position: initial;
            margin-bottom: 15px;

          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding: 0 7.3%;
            height: 64px;
            font-size: 13px;
            line-height: 21px;
            position: initial;
            margin-bottom: 25px;
          }
          span {
            width: 20%;
            height: 4px;
            background: rgba(174, 149, 79, 1);
            position: initial;
          }
        }
      }
    }
  }
}
@media (min-width: 321px) and (max-width: 360px) {
  .page-teacher {
    .teacher-section {
      .contents_wrap {
        height: 255px;
        .contents {
          height: 255px;
          img {
            top: 214px;
          }
        }
      }
      .content1_wrap {
        .content1 p {
          height: 84px;
        }
      }
      .content4_wrap {
        .content4 p {
          height: 85px;
        }
      }
    }
  }  
}
@media (min-width: 320px) and (max-width: 320px) {
  .page-teacher {
    .teacher-section {
      .contents_wrap {
        height: 270px;
        .contents {
          height: 270px;
          p {
            height: 222px;
          }
          img {
            top: 238px;
          }
        }
      }
      .content4_wrap {
        .content4 p {
          height: 85px;
        }
      }
    }
  } 
}
</style>


// WEBPACK FOOTER //
// src/pages/other/teacher.vue